import { LoginTokenResponseInterface } from '../../..';

export class LoginResponseDto implements LoginTokenResponseInterface{
  accessToken: string;
  refreshToken?: string;
}
